import { createSlice } from '@reduxjs/toolkit'

export const initialSize = 25

let initialState = {
    active: true,
    page: 1,
    size: initialSize,
    total: false
}

export const paginationSlice = createSlice({
    name: 'sort',
    initialState,
    reducers: {
        setActive: (state, action) => {
            state.active = action.payload
        },
        setPage: (state, action) => {
            state.page = action.payload
        },
        setItemsPerPage: (state, action) => {
            state.size = action.payload

            if (state.page > state.total) {
                state.page = 1
            }
        },
        setTotalItems: (state, action) => {
            state.total = Math.ceil(action.payload / state.size)

            if (state.page > state.total) {
                state.page = 1
            }
        },
        previousPage: (state) => {
            state.page = state.page - 1
        },
        nextPage: (state) => {
            state.page = state.page + 1
        }
    }
})

export const { setActive, setPage, setItemsPerPage, setTotalItems, nextPage, previousPage } =
    paginationSlice.actions

export const selectActive = (state) => state.pagination.active
export const selectPage = (state) => state.pagination.page
export const selectTotal = (state) => state.pagination.total
export const selectSize = (state) => state.pagination.size
export const selectPagination = (state) => state.pagination
export const selectCanPreviousPage = (state) => state.pagination.page > 1
export const selectNextPage = (state) => state.pagination.page < state.pagination.total
export const selectIsPaginationApplied = (state) => state.pagination.page !== 1

export default paginationSlice.reducer
